import React, { Component } from 'react'
import RequiredMark from './RequiredMark'

class InputWrapper extends Component {
  defaultClassNames = 'input-wrapper'

  wrapperClassNames() {
    let classNames = this.defaultClassNames + ' ' + (this.props.className || '')

    if(this.hasError()) {
      classNames += ' has-error'
    }
    return classNames
  }

  hasError() {
    return this.props.errorArray && this.props.errorArray.length > 0
  }

  renderLabel() {
    const { label, labelClassName, htmlFor, required } = this.props
    if (!label) return null

    return (
      <label className={`form-label ${labelClassName || ''}`} htmlFor={htmlFor}>
        {label}
        {required && <>{' '}<RequiredMark /></>}
      </label>
    )
  }

  renderErrorMessage() {
    if(this.hasError()) {
      return (
        <div className='invalid-feedback d-block'>{this.props.errorArray[0]}</div>
      )
    }
  }

  render() {
    return (
      <div className={this.wrapperClassNames()}>
        {this.renderLabel()}
        {this.props.children}
        {this.renderErrorMessage()}
      </div>
    )
  }
}

export default InputWrapper
